import Instruction from "./Instruction";

/**
 * A field in a Form, each will be bind to a variables by name, some display option are availible.
 *
 * To create a select you will need to use the isSelect method with the list of FormFieldOption.
 *
 * label can be resolve at runtime.
 */
class FormField extends Instruction
{
	constructor(name, label)
	{
		super();

		this.name = name;
		this.label = label;
		this.width = 'is-full';
		this.attributes = {
			type: 'text',
		};
		this.help = null;
		this.select = false;
		this.file = false;
		this.options = null;
	}
	setWidth(width)
	{
		this.width = width;

		return this;
	}
	setHelpMessage(help)
	{
		this.help = help;

		return this;
	}
	setAttribute(attribute, value)
	{
		this.attributes[attribute] = value;

		return this;
	}
	isRequired(required = true)
	{
		this.attributes.required = required;

		return this;
	}
	isSelect(options)
	{
		this.select = true;
		this.options = options;

		return this;
	}
	isFile()
	{
		this.file = true;

		return this;
	}
	resolve(variables)
	{
		super.resolve(variables);
		this.label = Instruction._resolveValue(this.label, variables);
	}
}

export default FormField
